class wholesaleSideCart {
  constructor() {
    this.cartContainer = document.getElementById("wholesale-side-cart");
    this.cartOpenButtons = document.querySelector(".wholesale-cart-open");
    this.body = document.body;
    this.init();
  }
  init() {
    let jsonCart = "";
    if (document.querySelector("#wholesale-dashboard")) {
      jsonCart = localStorage.getItem("business_cart_json");
      if (!cn(jsonCart)) {
        jsonCart = JSON.parse(jsonCart);
      }
    }
    this.reInit(jsonCart);
    this.bindEvents(this);
  }
  reInit(cartJson = null, openCart = false) {
    const cartPar = document.querySelector("#wholesale-side-cart");
    const itemsWrap = cartPar.querySelector(".sidecart-items");
    itemsWrap.innerHTML = "";
    let cartCount = 0;
    let cartTotal = 0;
    let cartWeight = 0;
    if (cartJson && cartJson.length) {
      cartJson.forEach((currItem, index) => {
        let cloneTemplate = cartPar.querySelector(".sidecart-item-clone .sidecart-item");
        let cloneLine = cloneTemplate.cloneNode(true);
        let itemTotal = parseFloat(currItem.price) * parseInt(currItem.quantity) * 100;
        cartTotal += itemTotal;
        const itemWeight = parseFloat(currItem.weight) * parseInt(currItem.quantity);
        cartWeight += itemWeight;
        cloneLine.querySelector(".sidecart-item-img").src = currItem.image;
        cloneLine.querySelector(".sidecart-item-title").textContent = currItem.title;
        cloneLine.querySelector(".sidecart-item-prop").textContent = currItem.product_title;
        cloneLine.querySelector(".sidecart-item-qty").value = currItem.quantity;
        cloneLine.querySelector(".sidecart-items-total").innerHTML = wetheme.formatMoney(itemTotal);
        cloneLine.dataset.index = index;
        itemsWrap.appendChild(cloneLine);
        cartCount += parseInt(currItem.quantity);
      });
      cartPar.querySelector(".sidecart-button").removeAttribute("disabled");
      localStorage.setItem("business_cart_json",JSON.stringify(cartJson));
    } else {
      itemsWrap.innerHTML = "<p class='side-cart-empty'>Your cart is empty</p>";
      cartPar.querySelector(".sidecart-button").setAttribute("disabled", "disabled");
      localStorage.removeItem("business_cart_json");
    }
    const getShip = tayst.getBusinessItemsShip.replace("items_weight",cartWeight);
    fetch(getShip).then((res) => res.json())
    .then((retdata) => {
      if (retdata.status == "0") {
        document.querySelector(".wholesale-cart-icon .wholesale-cart-icon-count").textContent = cartCount;
        cartPar.querySelector(".sidecart-item-counts").textContent = `(${cartCount})`;
        cartPar.querySelector(".sidecart-subtotal-text").innerHTML = wetheme.formatMoney(cartTotal);
        const shipCost = parseInt(retdata.ship_cost, 10) * 100;
        const shipCostElem = cartPar.querySelector(".sidecart-shipping-cost");
        shipCostElem.dataset.val = retdata.ship_cost;
        shipCostElem.innerHTML = wetheme.formatMoney(shipCost);
        const cartSubtotal = cartTotal + shipCost;
        cartPar.querySelector(".sidecart-total-text").innerHTML = wetheme.formatMoney(cartSubtotal);
        if (openCart) {
          cartPar.classList.add("active");
          document.documentElement.classList.add("overflow-hidden");
          document.body.classList.add("overflow-hidden");
        }
      } else {
        alert(
          "Something went wrong while fetching shipping. Login again or reload the page!"
        );
      }
    })
    .catch(() => {
      alert(
        "Failed to fetch shipping info! Please reload the page and try again."
      );
    });
  }
  bindEvents(that){
    document.addEventListener("click", function (e) {
      if (e.target.closest(".sidecart-min .sidecart-close")) {
        document.documentElement.classList.remove("overflow-hidden");
        document.body.classList.remove("overflow-hidden");
        document.querySelector("#wholesale-side-cart").classList.remove("active");
      }
      if (e.target.closest(".sidecart-min .sidecart-item-remove")) {
        const item = e.target.closest(".sidecart-item");
        const index = parseInt(item.dataset.index, 10);
        const cartJson = JSON.parse(localStorage.getItem("business_cart_json")) || [];
        cartJson.splice(index, 1);
        item.style.display = "none";
        that.reInit(cartJson);
      }
      if (e.target.closest(".sidecart-min .sidecart-qty-spin")) {
        const spinBtn = e.target.closest(".sidecart-qty-spin");
        const item = spinBtn.closest(".sidecart-item");
        const index = parseInt(item.dataset.index, 10);
        const cartJson = JSON.parse(localStorage.getItem("business_cart_json")) || [];

        const qtyInput = item.querySelector(".sidecart-item-qty");
        let qty = parseInt(qtyInput.value, 10);

        if (spinBtn.classList.contains("sidecart-qty-plus")) {
          qty++;
          qtyInput.value = qty;
          cartJson[index].quantity = qty;
          that.reInit(cartJson);
        } else {
          qty--;
          if (qty > 0) {
            qtyInput.value = qty;
            cartJson[index].quantity = qty;
            that.reInit(cartJson);
          } else {
            item.querySelector(".sidecart-item-remove").click();
          }
        }
      }
      if (e.target.closest("#wholesale-side-cart .sidecart-button")) {
        const btn = e.target.closest(".sidecart-button");
        const cartJson = JSON.parse(localStorage.getItem("business_cart_json"));
        const itemAttr = btn.getAttribute("data-attr");
        if (!cn(cartJson)) {
          btn.disabled = true;
          btn.classList.add("btn--loading");
          const userId = localStorage.getItem("buss_user");
          const custPO = document.querySelector("#wholesale-side-cart .sidecart-po-input").value;
          if (itemAttr != 1) {
            const cartArray = cartJson.map((item) => ({
              vid: item.id,
              quantity: item.quantity,
            }));
            fetch(tayst.placeOrderShopify, {
              method: "POST",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              body: new URLSearchParams({
                selected_items: JSON.stringify(cartArray),
                po_no: custPO,
                form_id: userId,
              }),
            }).then((r) => r.json())
            .then((ret) => {
              if (ret.status == 0) {
                localStorage.removeItem("business_cart_json");
                window.location.href = ret.order_status_url;
              } else {
                alert(ret.msg);
                btn.disabled = false;
                btn.classList.remove("btn--loading");
              }
            });
          }
          else {
            fetch(tayst.createCheckout, {
              method: "POST",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              body: new URLSearchParams({
                shopid: tayst.shopid,
                action: tayst.action.createCheckoutToken,
                selected_items: JSON.stringify(cartJson),
                form_id: userId,
                po_no: custPO,
                cart_shipping_cost: document.querySelector("#wholesale-side-cart .sidecart-shipping-cost").getAttribute("data-val"),
              }),
            }).then((r) => r.text())
            .then((ret) => {
              ret = JSON.parse(ret);
              if (ret.status == 0) {
                window.location.href = "/pages/business-checkout?token=" + ret.data;
              } else {
                alert(ret.msg);
                btn.disabled = false;
                btn.classList.remove("btn--loading");
              }
            });
          }
        }
      }
      if (!e.target.closest(".sidecart-min") && !e.target.closest(".wholesale-cart-open") && !e.target.closest(".sidecart-item")) {
        const cart = document.querySelector("#wholesale-side-cart");
        if (cart.classList.contains("active")) {
          document.documentElement.classList.remove("overflow-hidden");
          document.body.classList.remove("overflow-hidden");
          cart.classList.remove("active");
        }
      }
      if (e.target.closest(".wholesale-cart-open")) {
        e.preventDefault();
        document.documentElement.classList.add("overflow-hidden");
        document.body.classList.add("overflow-hidden");
        document.querySelector("#wholesale-side-cart").classList.add("active");
      }
    });
    document.addEventListener("change", function (e) {
      if (e.target.closest("#wholesale-side-cart .sidecart-ship-addr")) {
        const select = e.target.closest(".sidecart-ship-addr");
        const newVal = select.value;
        if (!confirm("Are you sure you want to change shipping location?")) {
          select.value = select.getAttribute("data-val");
          return;
        }
        const btn = document.querySelector("#wholesale-side-cart .sidecart-button");
        btn.disabled = true;
        fetch(tayst.interfaceBusinessSignup, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            action: tayst.action.update_shipping_address,
            id: newVal,
            shopid: tayst.shopid,
          }),
        }).then((r) => r.json())
        .then((ret) => {
          if (ret.status == 0) {
            select.setAttribute("data-val", newVal);
          } else {
            select.value = select.getAttribute("data-val");
            alert("Something went wrong. Refresh current page and try again!");
          }
          btn.disabled = false;
        });
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", () => {
  window.wholesaleSideCart = new wholesaleSideCart();
});